import { useEffect } from 'react';
import { AnimatePresence, m } from 'motion/react';
import { BrandLoader } from '@/components/page/brand-loader';
import { useOnboardingAnswersOptional } from '@/services/db/onboarding-answers/queries';
import { SLOW_02_EXIT_PRODUCTIVE_TRANSITION } from '@/utils/motion';
import { setIsAgentHandoffLoaderShowing, useIsAgentHandoffLoaderShowing } from '../agent-handoff';
import { agentHandoffLabels } from '../agent-handoff-labels';
import * as styles from './agent-handoff-overlay.css';

const MAX_LOADER_MS = 15_000;

export function AgentHandoffOverlay() {
  const isActive = useIsAgentHandoffLoaderShowing();
  const answersQuery = useOnboardingAnswersOptional({ queryConfig: { enabled: isActive } });

  useEffect(() => {
    if (!isActive) {
      return;
    }
    const timer = setTimeout(() => setIsAgentHandoffLoaderShowing(false), MAX_LOADER_MS);
    return () => clearTimeout(timer);
  }, [isActive]);

  return (
    <AnimatePresence>
      {isActive ? (
        <m.div
          key="agent-handoff"
          className={styles.overlay}
          exit={{ opacity: 0 }}
          transition={SLOW_02_EXIT_PRODUCTIVE_TRANSITION}
        >
          <BrandLoader labels={agentHandoffLabels(answersQuery.data?.answers)} isImmediate={true} />
        </m.div>
      ) : null}
    </AnimatePresence>
  );
}
